module.exports = __webpack_public_path__ + "static/media/Project-Consumer.af515097.svg";